const initialState = {
    userData: null,
};

const authReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case "LOGIN":
            return{
                ...state,
                userData: payload.data
            }
        default:
            return state;

    }
}

export default authReducer;